import React from "react";

export function QuestionMark() {
  return (
    <div className="question-mark-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 43 43">
        <g id="Group_3" data-name="Group 3" transform="translate(-2237 -2046)">
          <g
            id="Ellipse_12"
            data-name="Ellipse 12"
            transform="translate(2237 2046)"
            fill="none"
            stroke="#2175d9"
            strokeWidth="4"
          >
            <circle cx="21.5" cy="21.5" r="21.5" stroke="none" />
            <circle cx="21.5" cy="21.5" r="19.5" fill="none" />
          </g>
          <path
            id="Path_6"
            data-name="Path 6"
            d="M2253.721,2061.594c0-3.94,2.763-5.191,5.191-5.191a4.749,4.749,0,0,1,5.008,5.191c-.07,3.732-4.793,4.843-5.008,8.413-.034,2.1,0,2.568,0,2.568"
            fill="none"
            stroke="#2175d9"
            strokeLinecap="round"
            strokeWidth="3.5"
          />
          <circle
            id="Ellipse_13"
            data-name="Ellipse 13"
            cx="2"
            cy="2"
            r="2"
            transform="translate(2257 2077)"
            fill="#2175d9"
          />
        </g>
      </svg>
    </div>
  );
}

export function CheckMark() {
  return (
    <div className="check-mark-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        viewBox="0 0 66.433 47.551"
      >
        <path
          id="Icon_feather-check"
          data-name="Icon feather-check"
          d="M61.119,9,23.225,46.894,6,29.67"
          transform="translate(-0.343 -3.343)"
          fill="none"
          stroke="#0f1840"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="8"
        />
      </svg>
    </div>
  );
}

export function IntroductionImage() {
  return (
    <div className="image-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 1185 1531"
      >
        <path
          id="Rectangle_9"
          data-name="Rectangle 9"
          d="M167.5,0h0A167.5,167.5,0,0,1,335,167.5V848a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V167.5A167.5,167.5,0,0,1,167.5,0Z"
          transform="translate(425 683)"
          fill="#ffb511"
        />
        <path
          id="Rectangle_11"
          data-name="Rectangle 11"
          d="M167.5,0h0A167.5,167.5,0,0,1,335,167.5V1107a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V167.5A167.5,167.5,0,0,1,167.5,0Z"
          transform="translate(850 424)"
          fill="#e64436"
        />
        <path
          id="Rectangle_3"
          data-name="Rectangle 3"
          d="M167.5,0h0A167.5,167.5,0,0,1,335,167.5V596a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V167.5A167.5,167.5,0,0,1,167.5,0Z"
          transform="translate(0 935)"
          fill="#ffb511"
        />
        <path
          id="Rectangle_8"
          data-name="Rectangle 8"
          d="M167.5,0h0A167.5,167.5,0,0,1,335,167.5V596a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V167.5A167.5,167.5,0,0,1,167.5,0Z"
          transform="translate(425 935)"
          fill="#2075d8"
        />
        <path
          id="Rectangle_10"
          data-name="Rectangle 10"
          d="M167.5,0h0A167.5,167.5,0,0,1,335,167.5V855a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V167.5A167.5,167.5,0,0,1,167.5,0Z"
          transform="translate(850 676)"
          fill="#feb510"
        />
        <circle
          id="Ellipse_5"
          data-name="Ellipse 5"
          cx="167.5"
          cy="167.5"
          r="167.5"
          transform="translate(0 516)"
          fill="#feb510"
        />
        <circle
          id="Ellipse_10"
          data-name="Ellipse 10"
          cx="167.5"
          cy="167.5"
          r="167.5"
          transform="translate(425 256)"
          fill="#e64436"
        />
        <circle
          id="Ellipse_11"
          data-name="Ellipse 11"
          cx="167.5"
          cy="167.5"
          r="167.5"
          transform="translate(850)"
          fill="#2075d8"
        />
        <ellipse
          id="Ellipse_6"
          data-name="Ellipse 6"
          cx="167.5"
          cy="168"
          rx="167.5"
          ry="168"
          transform="translate(0 935)"
          fill="#2075d8"
        />
      </svg>
    </div>
  );
}

export function ArrowIcon({ className }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        viewBox="0 0 96.401 55.119"
      >
        <path
          id="Icon_ionic-ios-arrow-down"
          data-name="Icon ionic-ios-arrow-down"
          d="M54.406,49.75,90.857,13.27a6.86,6.86,0,0,1,9.73,0,6.947,6.947,0,0,1,0,9.759l-41.3,41.33a6.876,6.876,0,0,1-9.5.2L8.2,23.057a6.89,6.89,0,0,1,9.73-9.759Z"
          transform="translate(-6.188 -11.246)"
        />
      </svg>
    </div>
  );
}
export function ArrowNext({ className }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.259"
        height="16.874"
        viewBox="0 0 27.259 16.874"
      >
        <path
          id="Icon_awesome-arrow-right"
          data-name="Icon awesome-arrow-right"
          d="M3.307,3.777l.858-.858a.924.924,0,0,1,1.31,0l7.512,7.508a.924.924,0,0,1,0,1.31L5.475,19.249a.924.924,0,0,1-1.31,0l-.858-.858a.928.928,0,0,1,.015-1.325L7.979,12.63H-13.073A.925.925,0,0,1-14,11.7V10.466a.925.925,0,0,1,.927-.927H7.979L3.322,5.1A.922.922,0,0,1,3.307,3.777Z"
          transform="translate(14 -2.647)"
          fill="#fff"
        />
      </svg>
    </div>
  );
}

export function ContactIcon() {
  return (
    <div className="contact-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 1012.951 683.619"
      >
        <g
          id="Intersection_3"
          data-name="Intersection 3"
          transform="translate(-0.024 -130.381)"
          fill="#e64436"
        >
          <path
            d="M 808.7013549804688 813.4996337890625 L 204.2986297607422 813.4996337890625 L 0.7312563061714172 609.9328002929688 L 460.8916320800781 149.7723999023438 C 467.0488891601562 143.6151580810547 474.2275085449219 138.8480224609375 482.2282409667969 135.6035308837891 C 486.0736389160156 134.0440216064453 490.0948791503906 132.8522796630859 494.1802673339844 132.061279296875 C 498.2270202636719 131.2777862548828 502.3720092773438 130.8805236816406 506.4998779296875 130.8805236816406 C 510.6278686523438 130.8805236816406 514.7727661132812 131.2777862548828 518.8196411132812 132.061279296875 C 522.905029296875 132.8522796630859 526.9263916015625 134.0440216064453 530.771728515625 135.6035308837891 C 538.7726440429688 138.8480224609375 545.9514770507812 143.6151580810547 552.10888671875 149.7723999023438 L 1012.268249511719 609.9328002929688 L 808.7013549804688 813.4996337890625 Z"
            stroke="none"
          />
          <path
            d="M 808.494140625 812.9996337890625 L 1011.56103515625 609.9328002929688 L 551.7552490234375 150.1260223388672 C 545.6455078125 144.0162811279297 538.5223999023438 139.2860260009766 530.5838623046875 136.0667724609375 C 526.7683715820312 134.51953125 522.7782592773438 133.3370361328125 518.7244873046875 132.5521545410156 C 514.708984375 131.7747802734375 510.5960083007812 131.3805236816406 506.4998779296875 131.3805236816406 C 502.4037475585938 131.3805236816406 498.2908935546875 131.7747802734375 494.275390625 132.5521545410156 C 490.2216186523438 133.3370361328125 486.2316284179688 134.51953125 482.4161376953125 136.0667724609375 C 474.4777526855469 139.2860260009766 467.3548889160156 144.0162811279297 461.2452697753906 150.1260223388672 L 1.438506722450256 609.9328002929688 L 204.5058746337891 812.9996337890625 L 808.494140625 812.9996337890625 M 808.9083862304688 813.9996337890625 L 204.0916290283203 813.9996337890625 L 0.02425585873425007 609.9328002929688 L 460.5381164550781 149.4188995361328 C 485.9217834472656 124.0344619750977 527.077880859375 124.0343627929688 552.46240234375 149.4188995361328 L 1012.975280761719 609.9328002929688 L 808.9083862304688 813.9996337890625 Z"
            stroke="none"
            fill="#707070"
          />
        </g>
        <path
          id="Rectangle_12"
          data-name="Rectangle 12"
          d="M30,0H735a30,30,0,0,1,30,30V478a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V30A30,30,0,0,1,30,0Z"
          transform="translate(122.976 205.619)"
          fill="#ffb50f"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M0,0,204,204H0Z"
          transform="translate(1.976 479.619)"
          fill="#0f1841"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M0,0,204,204H0Z"
          transform="translate(807.976 683.619) rotate(-90)"
          fill="#0f1841"
        />
      </svg>
    </div>
  );
}

export function MailIcon() {
  return (
    <div className="mail-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 82 56">
        <g
          id="Rectangle_15"
          data-name="Rectangle 15"
          fill="none"
          stroke="#0f1841"
          strokeWidth="7"
        >
          <rect width="82" height="56" rx="6" stroke="none" />
          <rect x="3.5" y="3.5" width="75" height="49" rx="2.5" fill="none" />
        </g>
        <path
          id="Path_5"
          data-name="Path 5"
          d="M2152.647,1940.525l36.067,19.525,37.488-19.525"
          transform="translate(-2148 -1931)"
          fill="none"
          stroke="#0f1841"
          strokeWidth="7"
        />
      </svg>
    </div>
  );
}

export function CloseIcon() {
  return (
    <div className="close-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        viewBox="0 0 20.953 20.953"
      >
        <path
          id="Icon_ionic-md-close"
          data-name="Icon ionic-md-close"
          d="M28.477,9.619l-2.1-2.1L18,15.9,9.619,7.523l-2.1,2.1L15.9,18,7.523,26.381l2.1,2.1L18,20.1l8.381,8.381,2.1-2.1L20.1,18Z"
          transform="translate(-7.523 -7.523)"
          fill="#2075d8"
        />
      </svg>
    </div>
  );
}

export function ArrowBackIcon({ color, className }) {
  return (
    <div className={`arrow-back-icon ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        viewBox="0 0 40.046 33.378"
      >
        <path
          id="Icon_ionic-ios-arrow-round-back"
          data-name="Icon ionic-ios-arrow-round-back"
          d="M26.013,11.891a2.271,2.271,0,0,1,.017,3.2L15.478,25.676H45.686a2.26,2.26,0,0,1,0,4.52H15.478L26.047,40.781a2.288,2.288,0,0,1-.017,3.2,2.251,2.251,0,0,1-3.181-.017L8.525,29.535h0a2.538,2.538,0,0,1-.469-.713,2.157,2.157,0,0,1-.174-.869,2.266,2.266,0,0,1,.643-1.582L22.849,11.943A2.214,2.214,0,0,1,26.013,11.891Z"
          transform="translate(-7.882 -11.252)"
          fill={color}
        />
      </svg>
    </div>
  );
}

export function FlowerIcon({ color, className }) {
  return (
    <div className={` ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 1359.465 1435.92"
      >
        <g id="Group_4" data-name="Group 4" transform="translate(-0.001)">
          <rect
            id="Rectangle_1"
            data-name="Rectangle 1"
            width="73.466"
            height="567.689"
            transform="translate(284.195 868.231)"
            fill="#fff"
          />
          <rect
            id="Rectangle_2"
            data-name="Rectangle 2"
            width="33.393"
            height="1128.7"
            transform="translate(691.596 307.22)"
            fill="#fff"
          />
          <rect
            id="Rectangle_3"
            data-name="Rectangle 3"
            width="33.393"
            height="694.585"
            transform="translate(1058.924 741.336)"
            fill="#fff"
          />
          <circle
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="303.881"
            cy="303.881"
            r="303.881"
            transform="translate(23.726 307.22)"
            fill="#e74636"
          />
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="283.845"
            cy="283.845"
            r="283.845"
            transform="translate(791.776 447.473)"
            fill="#e74636"
          />
          <circle
            id="Ellipse_3"
            data-name="Ellipse 3"
            cx="190.343"
            cy="190.343"
            r="190.343"
            transform="translate(517.95)"
            fill="#e74636"
          />
          <ellipse
            id="Ellipse_4"
            data-name="Ellipse 4"
            cx="144.834"
            cy="67.241"
            rx="144.834"
            ry="67.241"
            transform="translate(95.094 1088.628) rotate(45)"
            fill="#6da4b2"
          />
          <ellipse
            id="Ellipse_5"
            data-name="Ellipse 5"
            cx="101.423"
            cy="47.205"
            rx="101.423"
            ry="47.205"
            transform="translate(1319.647 1221.501) rotate(138)"
            fill="#6da4b2"
          />
        </g>
      </svg>
    </div>
  );
}

export function RandstadLogo({ color, className }) {
  return (
    <div className={` ${className}`}>
      <svg
        version="1.1"
        id="RandstadLogo"
        xmlns="http://www.w3.org/2000/svg"
        xmlns='xlink="http://www.w3.org/1999/xlink"'
        width="100%"
        x="0px"
        y="0px"
        viewBox="0 0 200.6 30"
        fill="#FFF"
      >
        <style type="text/css"></style>
        <path
          className="st0"
          d="M15.6,29.5h4.4V18.3c0-0.6-0.2-1.2-0.6-1.6l-6.6-6.6c-0.4-0.4-1-0.7-1.6-0.7H0v4.5h12.3c1.8,0,3.3,1.5,3.4,3.3
	l0,0L15.6,29.5z"
        />
        <path
          className="st0"
          d="M26.7,29.5h-4.5V18.3c0-0.6,0.2-1.2,0.6-1.6l6.6-6.6c0.4-0.4,1-0.7,1.6-0.7h11.2v4.5H30c-1.8,0-3.3,1.5-3.4,3.3
	l0,0L26.7,29.5z"
        />
        <path
          className="st0"
          d="M62.4,9.4h3.5v3.1H66c0.9-2.1,2.9-3.4,5.2-3.5c0.8,0,1.6,0.1,2.4,0.3v3.3c-0.6-0.2-1.3-0.4-2-0.4
	c-3.3,0-5.5,3.1-5.5,8.2v9.1h-3.7V9.4z"
        />
        <path
          className="st0"
          d="M175.4,21.7c0,3-2,5.3-5.6,5.3c-1.7,0-3.7-1.1-3.7-3.3c0-3.6,4.9-3.9,6.9-3.9c0.8,0,1.6,0.1,2.4,0.1V21.7z
	 M164.6,14c1.6-1.3,3.7-2.1,5.8-2.1c3.7,0,4.9,1.8,4.9,5.3c-1.4-0.1-2.5-0.1-3.9-0.1c-3.8,0-9.3,1.6-9.3,6.6c0,4.4,3,6.3,7.4,6.3
	c2.4,0.1,4.7-1,6.2-3h0.1v2.5h3.3V17.2c0-5.5-2.3-8.3-8-8.3c-2.3,0-4.6,0.7-6.6,1.9L164.6,14z"
        />
        <path
          className="st0"
          d="M86.1,21.7c0,3-2,5.3-5.6,5.3c-1.7,0-3.7-1.1-3.7-3.3c0-3.6,5-3.9,7-3.9c0.8,0,1.6,0.1,2.3,0.1L86.1,21.7z
	 M75.4,14c1.7-1.4,3.7-2.1,5.9-2.1c3.7,0,5,1.8,5,5.3c-1.4-0.1-2.5-0.1-3.9-0.1c-3.8,0-9.3,1.6-9.3,6.6c0,4.4,3,6.3,7.3,6.3
	c2.4,0.1,4.7-1,6.2-3h0.1v2.5h3.3V17.2c0-5.5-2.3-8.3-8-8.3c-2.3,0-4.6,0.7-6.6,1.9L75.4,14z"
        />
        <path
          className="st0"
          d="M92.9,9.4h3.6v3.1h0.1c1.3-2.4,3.9-3.8,6.6-3.6c5.2,0,7.5,3.2,7.5,8.6v12h-3.7V19.1c0-4.7-1-7-4.2-7.2
	c-4.2,0-6.1,3.4-6.1,8.3v9.3h-3.7V9.4z"
        />
        <path
          className="st0"
          d="M134.6,25.6c1.4,0.9,3,1.3,4.6,1.4c1.7,0,3.8-0.7,3.8-2.9c0-3.7-8.7-3.4-8.7-9c0-4.2,3.1-6.2,7.1-6.2
	c1.6,0,3.1,0.3,4.6,0.8l-0.3,3.2c-1.2-0.6-2.6-0.9-3.9-1c-1.9,0-3.5,0.8-3.5,2.5c0,4.1,8.7,2.9,8.7,9.4c0,4.3-3.4,6.3-7,6.3
	c-1.9,0.1-3.8-0.3-5.5-1.1L134.6,25.6z"
        />
        <path
          className="st0"
          d="M161,12.4h-5.3v11c0,2.3,1.4,3.6,3.1,3.6c0.9,0,1.8-0.2,2.5-0.7v3.1c-1,0.3-2.1,0.5-3.1,0.5
	c-3.8,0-6.1-1.8-6.1-5.8V12.4h-4.5V9.5h4.5V4.8l3.7-1.2v5.8h5.3V12.4z"
        />
        <path
          className="st0"
          d="M185.5,19.4c-0.1-3.7,1.5-7.5,5.5-7.5s6,3.8,6,7.6c0,3.4-1.7,7.5-5.9,7.5C187.1,27,185.4,22.5,185.5,19.4z
	 M197.1,29.5h3.5V0H197v12.2h-0.1c-1.1-1.9-3.1-3.2-6.6-3.2c-5.8,0-8.6,4.8-8.6,10.2s2.5,10.9,8.6,10.9c2.7,0.1,5.3-1.1,6.9-3.3h0.1
	L197.1,29.5z"
        />
        <path
          className="st0"
          d="M117,19.4c-0.1-3.7,1.5-7.5,5.5-7.5s5.9,3.8,5.9,7.6c0,3.4-1.7,7.5-5.9,7.5C118.6,27,116.9,22.5,117,19.4z
	 M128.6,29.5h3.5V0h-3.7v12.2h-0.1c-1.1-1.9-3.1-3.2-6.6-3.2c-5.8,0-8.7,4.8-8.7,10.2s2.6,10.9,8.6,10.9c2.7,0.1,5.3-1.1,6.9-3.3
	h0.1L128.6,29.5z"
        />
      </svg>
    </div>
  );
}

export function RandstadIcon({ color, className }) {
  return (
    <div className={` ${className}`}>
      <svg
        id="RandstadIcon"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 42.3 20.05"
        fill="#2175d9"
      >
        <path
          className="cls-1"
          d="M15.61,20.05h4.45V8.85a2.2,2.2,0,0,0-.65-1.59L12.8.66A2.2,2.2,0,0,0,11.22,0H0V4.46H12.26a3.35,3.35,0,0,1,3.35,3.35h0Z"
        />
        <path
          className="cls-1"
          d="M26.7,20.05H22.24V8.85a2.2,2.2,0,0,1,.65-1.59L29.5.66A2.2,2.2,0,0,1,31.08,0H42.3V4.46H30a3.35,3.35,0,0,0-3.35,3.35h0Z"
        />
      </svg>
    </div>
  );
}

export function BlueCircle({ color, className }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 470.001 469"
      >
        <g
          id="Subtraction_1"
          data-name="Subtraction 1"
          transform="translate(470.001 -170) rotate(90)"
          fill="none"
        >
          <path
            d="M639,470H340a171.258,171.258,0,0,0-3.454-34.262,169.071,169.071,0,0,0-25.58-60.788,170.5,170.5,0,0,0-74.8-61.592,169.146,169.146,0,0,0-31.911-9.906A171.26,171.26,0,0,0,170,300V0a476.939,476.939,0,0,1,47.958,2.472A470.669,470.669,0,0,1,264.53,9.627c15.111,3.107,30.234,7.01,44.949,11.6,14.551,4.54,29.049,9.859,43.092,15.812,13.913,5.9,27.707,12.555,41,19.787,13.2,7.181,26.207,15.1,38.669,23.527a472.124,472.124,0,0,1,126.674,126.8c8.419,12.471,16.322,25.489,23.49,38.693,7.219,13.3,13.863,27.1,19.747,41.02,5.939,14.049,11.244,28.554,15.769,43.111,4.576,14.722,8.464,29.851,11.555,44.967a470.669,470.669,0,0,1,7.106,46.587A477.011,477.011,0,0,1,639,469.5c0,.173,0,.325,0,.5Z"
            stroke="none"
          />
          <path
            d="M 638.9993286132812 470.000732421875 L 340.0004272460938 470.000732421875 C 340.0004272460938 458.467529296875 338.838623046875 446.9403686523438 336.5464782714844 435.7389526367188 C 334.3129272460938 424.8239440917969 330.9800720214844 414.087890625 326.6407775878906 403.8282470703125 C 322.3800659179688 393.75537109375 317.1068420410156 384.0396728515625 310.9668579101562 374.9514465332031 C 304.8854064941406 365.9496765136719 297.901123046875 357.4846801757812 290.2082824707031 349.7918090820312 C 282.5154113769531 342.0989379882812 274.0504150390625 335.1146545410156 265.0486450195312 329.0332336425781 C 255.9604187011719 322.8932495117188 246.2447052001953 317.6196594238281 236.1714935302734 313.3593139648438 C 225.9122009277344 309.02001953125 215.1761322021484 305.6871643066406 204.2611389160156 303.4535827636719 C 193.0611267089844 301.1618041992188 181.5339965820312 299.9996643066406 170.0000610351562 299.9996643066406 L 170.0000610351562 2.432686960673891e-05 C 186.0043487548828 0.01752432622015476 202.1397094726562 0.8496671915054321 217.9586334228516 2.472167253494263 C 233.5522003173828 4.071810245513916 249.2214965820312 6.478952884674072 264.5300598144531 9.626452445983887 C 279.6411437988281 12.7335958480835 294.7639770507812 16.63645362854004 309.4793395996094 21.22752380371094 C 324.03076171875 25.76716804504395 338.5289916992188 31.0868091583252 352.5711364746094 37.0389518737793 C 366.4839782714844 42.93645477294922 380.2775573730469 49.59395217895508 393.5690002441406 56.82609558105469 C 406.7661437988281 64.00716400146484 419.776123046875 71.92288208007812 432.2379150390625 80.35324096679688 C 457.0725708007812 97.15359497070312 480.4247131347656 116.4425277709961 501.646484375 137.6846618652344 C 522.86865234375 158.9271697998047 542.1354370117188 182.2985992431641 558.9114990234375 207.1493072509766 C 567.3304443359375 219.6200256347656 575.2332763671875 232.6382446289062 582.4014892578125 245.842529296875 C 589.6207885742188 259.1414489746094 596.2647094726562 272.9425354003906 602.1486206054688 286.8628845214844 C 608.0872192382812 300.9121704101562 613.3929443359375 315.4168090820312 617.9175415039062 329.9743041992188 C 622.4940185546875 344.6964416503906 626.3818359375 359.8253784179688 629.472900390625 374.9411010742188 C 632.6050415039062 390.25537109375 634.9957885742188 405.9296569824219 636.5789794921875 421.5285949707031 C 638.1854248046875 437.3564453125 639.0000610351562 453.4964599609375 639.0000610351562 469.5003662109375 C 639.0000610351562 469.673583984375 639.0000610351562 469.8257446289062 638.9993286132812 469.9996643066406 L 638.9993286132812 470.000732421875 Z"
            stroke="none"
            fill="#6ca3b4"
          />
        </g>
      </svg>
    </div>
  );
}

export function RedCircle({ color, className }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 470.001 469"
      >
        <g
          id="Subtraction_2"
          data-name="Subtraction 2"
          transform="translate(0 639) rotate(-90)"
          fill="none"
        >
          <path
            d="M639,470H340a171.258,171.258,0,0,0-3.454-34.262,169.071,169.071,0,0,0-25.58-60.788,170.5,170.5,0,0,0-74.8-61.592,169.146,169.146,0,0,0-31.911-9.906A171.26,171.26,0,0,0,170,300V0a476.939,476.939,0,0,1,47.958,2.472A470.669,470.669,0,0,1,264.53,9.627c15.111,3.107,30.234,7.01,44.949,11.6,14.551,4.54,29.049,9.859,43.092,15.812,13.913,5.9,27.707,12.555,41,19.787,13.2,7.181,26.207,15.1,38.669,23.527a472.124,472.124,0,0,1,126.674,126.8c8.419,12.471,16.322,25.489,23.49,38.693,7.219,13.3,13.863,27.1,19.747,41.02,5.939,14.049,11.244,28.554,15.769,43.111,4.576,14.722,8.464,29.851,11.555,44.967a470.669,470.669,0,0,1,7.106,46.587A477.011,477.011,0,0,1,639,469.5c0,.173,0,.325,0,.5Z"
            stroke="none"
          />
          <path
            d="M 638.9993286132812 470.000732421875 L 340.0004272460938 470.000732421875 C 340.0004272460938 458.467529296875 338.838623046875 446.9403686523438 336.5464782714844 435.7389526367188 C 334.3129272460938 424.8239440917969 330.9800720214844 414.087890625 326.6407775878906 403.8282470703125 C 322.3800659179688 393.75537109375 317.1068420410156 384.0396728515625 310.9668579101562 374.9514465332031 C 304.8854064941406 365.9496765136719 297.901123046875 357.4846801757812 290.2082824707031 349.7918090820312 C 282.5154113769531 342.0989379882812 274.0504150390625 335.1146545410156 265.0486450195312 329.0332336425781 C 255.9604187011719 322.8932495117188 246.2447052001953 317.6196594238281 236.1714935302734 313.3593139648438 C 225.9122009277344 309.02001953125 215.1761322021484 305.6871643066406 204.2611389160156 303.4535827636719 C 193.0611267089844 301.1618041992188 181.5339965820312 299.9996643066406 170.0000610351562 299.9996643066406 L 170.0000610351562 2.432686960673891e-05 C 186.0043487548828 0.01752432622015476 202.1397094726562 0.8496671915054321 217.9586334228516 2.472167253494263 C 233.5522003173828 4.071810245513916 249.2214965820312 6.478952884674072 264.5300598144531 9.626452445983887 C 279.6411437988281 12.7335958480835 294.7639770507812 16.63645362854004 309.4793395996094 21.22752380371094 C 324.03076171875 25.76716804504395 338.5289916992188 31.0868091583252 352.5711364746094 37.0389518737793 C 366.4839782714844 42.93645477294922 380.2775573730469 49.59395217895508 393.5690002441406 56.82609558105469 C 406.7661437988281 64.00716400146484 419.776123046875 71.92288208007812 432.2379150390625 80.35324096679688 C 457.0725708007812 97.15359497070312 480.4247131347656 116.4425277709961 501.646484375 137.6846618652344 C 522.86865234375 158.9271697998047 542.1354370117188 182.2985992431641 558.9114990234375 207.1493072509766 C 567.3304443359375 219.6200256347656 575.2332763671875 232.6382446289062 582.4014892578125 245.842529296875 C 589.6207885742188 259.1414489746094 596.2647094726562 272.9425354003906 602.1486206054688 286.8628845214844 C 608.0872192382812 300.9121704101562 613.3929443359375 315.4168090820312 617.9175415039062 329.9743041992188 C 622.4940185546875 344.6964416503906 626.3818359375 359.8253784179688 629.472900390625 374.9411010742188 C 632.6050415039062 390.25537109375 634.9957885742188 405.9296569824219 636.5789794921875 421.5285949707031 C 638.1854248046875 437.3564453125 639.0000610351562 453.4964599609375 639.0000610351562 469.5003662109375 C 639.0000610351562 469.673583984375 639.0000610351562 469.8257446289062 638.9993286132812 469.9996643066406 L 638.9993286132812 470.000732421875 Z"
            stroke="none"
            fill="#e74436"
          />
        </g>
      </svg>
    </div>
  );
}
